export default __webpack_public_path__ + "static/media/navigation.7bcc024d.jpg";